import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Drawer, Divider } from 'antd';
import { _newLine } from '@/utils/helpers';
import CKEditorComponent from '@/components/Editor/CKEditorComponent'
import { isMobile } from 'react-device-detect';
import DocumentFileUpload from '@/routes/documents/DocumentFileUpload';
import { updateProjectJobResult } from '@/redux/actions/projectJobActions';

class UpdateResultForm extends Component {
    constructor() {
        super();
        this.state = {
            isloading: false,
            resultFiles: [],
            fileResetKey: 0
        };
    }

    componentDidUpdate(prevProps) {
        const opened = this.props.visible && !prevProps.visible;
        const changedItem = this.props.visible && prevProps.currentData?.id !== this.props.currentData?.id;
        if (opened || changedItem) {
            this.setState({
                resultFiles: this.props.currentData?.result_attached_files || [],
                fileResetKey: this.state.fileResetKey + 1
            });
        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({ isloading: true })
                    if (this.props.currentData) {
                        values.result_attached_files = this.state.resultFiles;
                        await this.props.updateProjectJobResult(this.props.currentData.id, values);
                        this.props.reloadData()
                        this.handCancel()
                    }
                    //console.log(values)
                    this.setState({ isloading: false })
                } catch (error) {
                    this.setState({ isloading: false });
                }
            }
        });
    }

    handCancel() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isloading: false,
            resultFiles: [],
            fileResetKey: this.state.fileResetKey + 1
        })
    }

    render() {
        const { isloading, resultFiles, fileResetKey } = this.state;
        var { visible, currentData } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title="Cập nhật kết quả công việc"
                onOk={(e) => this.submit(e)}
                onClose={() => this.handCancel()}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.handCancel()}>
                            Huỷ
                        </Button>
                        <Divider type='vertical' />
                        <Button loading={isloading} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentData ? "Cập nhật" : "Tạo"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Form layout="vertical">
                            <Form.Item label="Nội dung">
                                {getFieldDecorator('result_content', {
                                    rules: [
                                        {
                                            required: false,
                                            message: 'Field is required.'
                                        }
                                    ],
                                    initialValue: currentData ? _newLine(currentData?.result_content) : null
                                })(
                                    <CKEditorComponent
                                        initialHeight="300px"
                                        editorData={currentData?.result_content}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                        <Form.Item label="Tệp đính kèm">
                            <DocumentFileUpload
                                resetKey={`project-job-result-${currentData?.id || 'new'}-${fileResetKey}`}
                                value={resultFiles}
                                onChange={files => this.setState({ resultFiles: files })}
                            />
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('result_note', {
                                rules: [
                                    {
                                        required: false,
                                        message: "Vui lòng chọn!",
                                    },
                                ],
                                initialValue: currentData ? _newLine(currentData.result_note) : ''
                            })(
                                <Input.TextArea rows={4} />
                            )}
                        </Form.Item>
                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateProjectJobResult: (id, data) => dispatch(updateProjectJobResult(id, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'UpdateResultForm' })(UpdateResultForm));
